export const ROUTES = {
  // Main routes
  HOME: "/",
  
  // Store routes
  STORE: "/loja",
  STORE_CATEGORY: (categorySlug: string) => `/loja/${categorySlug}`,
  
  // Workshop routes
  WORKSHOP: "/oficina",
  
  PRODUCT_DETAILS: (id: string) => `/product-details?id=${id}`,

  // Mobility routes
  MOBILITY: "/mobilidade",
  
  // Budget routes
  BUDGET: "/orcamento",
  
  // Contact routes
  WE_CALL: "/ligamos",
  CONTACT: "/contacto",
  
  // Other routes
  RECRUITMENT: "/recrutamento",
  
  // Product routes
  PRODUCT: (id: string) => `/produto/${id}`,
  
  // Service routes (workshop services)
  ALIGNMENT: "/alinhamento",
  DIAGNOSTIC_TEST: "/teste-diagnostico",
  ROADY_REVIEW: "/revisoes-roady",
  SHOCK_ABSORBERS: "/amortecedores",
  INSPECTION: "/inspecao",
  GENERAL_MECHANICS: "/mecanica-geral",
  WORKSHOP_SERVICES: "/servicos-oficina",
  AIR_CONDITIONING: "/ar-condicionado",
  WASHING: "/lavagem",
  HEADLIGHT_RESTORATION: "/restauro-farois",
  BATTERIES: "/baterias",
  BRAKES: "/travoes",
  
  // Legal routes
  TERMS: "/termos-condicoes",
  PRIVACY: "/politica-privacidade",
  COOKIES_POLICY: "/politica-cookies",
  COOKIE_CONSENT: "/consentimento-cookies",
  
  // Admin routes
  ADMIN: '/admin',
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_CATALOG: '/admin/catalog',
  ADMIN_VIDEOS: '/admin/videos',
  ADMIN_HORARIO: '/admin/horario',
  ADMIN_PRICINGS: '/admin/pricings',
  ADMIN_ANALYTICS: '/admin/analytics',
};

export default ROUTES;

